<div class="flex flex-col items-center h-full px-6 md:px-12 lg:px-27">
    <div *ngIf="!showSuccessMessage" class="center-flex-col w-full md:w-1/2 gap-4 py-18">
        <div class="flex items-center">
            <span class="h3-text text-text-primary text-center w-full" i18n>Contact us</span>
        </div>
        <p class="body-s-text text-center text-text-muted" i18n>Have any questions or need assistance? Feel free to contact us! We’re here to help.</p>
        <mat-form-field class="w-full" subscriptSizing="dynamic">
            <img matPrefix src="assets/icons/dark/mail.svg" class="prefix-icon" alt="email icon"/>
            <input matInput i18n-placeholder placeholder="Your email" [(ngModel)]="email">
        </mat-form-field>
        <mat-form-field class="w-full" subscriptSizing="dynamic">
            <textarea rows="7" maxlength="2000" matInput i18n-placeholder placeholder="Please provide your feedback here" [(ngModel)]="message"></textarea>
        </mat-form-field>
        <button type="submit" class="primary-button"
                (click)="submitFeedback()" i18n>Send feedback</button>
    </div>
    <div *ngIf="showSuccessMessage" class="flex justify-center items-center flex-col w-full md:w-1/2 gap-4 py-18">
        <div class="flex items-center">
          <span *ngIf="userName == null" class="h3-text text-text-primary text-center w-full" i18n>Thank you!</span>
          <span *ngIf="userName != null" class="h3-text text-text-primary text-center w-full" i18n>Thank you, {{userName}}!</span>
        </div>
        <p class="body-s-text text-center text-text-muted" i18n>We have received your feedback and will get back to you as soon as possible.</p>
        <div class="flex center-flex-col sm:w-full md:w-44">
          <button type="button" class="secondary-button" routerLink="/home" i18n>Back to home page</button>
        </div>
    </div>
</div>
